import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import { RouteLevelProvider } from './context.js';
import { useLocationPath } from './context.js';
import { useRouteMatchesForPath } from './hooks.js';
import { joinPaths } from './util.js';
/**
 * Render a specific route's UI, even if the current URL doesn't
 * match it.
 */
export function RouteRenderer({ value, params }) {
    useEffect(() => {
        var _a, _b;
        return (_b = value === null || value === void 0 ? void 0 : (_a = value.route).onVisited) === null || _b === void 0 ? void 0 : _b.call(_a, value.params);
    }, [value]);
    const paramsToPass = useMemo(() => (Object.assign(Object.assign({}, value.params), params)), [value.params, params]);
    if (!(value === null || value === void 0 ? void 0 : value.route.component))
        return null;
    const Component = value.route.component;
    return (_jsx(RouteLevelProvider, { match: value, params: paramsToPass, children: _jsx(MemoizedComponentRenderer, { Component: Component }) }));
}
// idk if this... does anything...
const MemoizedComponentRenderer = memo(function MemoizedComponentRenderer({ Component, }) {
    return _jsx(Component, {});
});
/**
 * Renders the leaf-most route that matches the provided path.
 * To render the entire route tree, use RouteTree.
 */
export function Route({ path }) {
    const basePath = useLocationPath();
    const resolvedPath = path.startsWith('/') ? path : joinPaths(basePath, path);
    const matches = useRouteMatchesForPath(resolvedPath);
    const match = matches[matches.length - 1];
    if (!match)
        return null;
    return _jsx(RouteRenderer, { value: match });
}
/**
 * Renders the top-to-bottom route tree matching the provided path.
 */
export function RouteTree({ path, skip = 0 }) {
    const basePath = useLocationPath();
    const resolvedPath = path.startsWith('/') ? path : joinPaths(basePath, path);
    const matches = useRouteMatchesForPath(resolvedPath);
    const match = matches[skip];
    if (!match)
        return null;
    return _jsx(RouteRenderer, { value: match });
}
//# sourceMappingURL=Route.js.map